export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NL_STATUS = {
  draft: { label: 'Brouillon', dot: '#eab308', bg: 'rgba(234,179,8,0.12)', text: '#eab308' },
  scheduled: { label: 'Programmée', dot: '#3b82f6', bg: 'rgba(59,130,246,0.12)', text: '#3b82f6' },
  sending: { label: 'Envoi en cours', dot: '#f97316', bg: 'rgba(249,115,22,0.12)', text: '#f97316' },
  sent: { label: 'Envoyée', dot: '#22c55e', bg: 'rgba(34,197,94,0.12)', text: '#22c55e' },
  error: { label: 'Erreur', dot: '#ef4444', bg: 'rgba(239,68,68,0.12)', text: '#ef4444' },
};

export const NL_CATEGORIES = ['Film', 'Série', 'Podcast', 'Documentaire', 'Jeunesse', 'Nouveautés', 'Promotions', 'Ramadan', 'Information', 'Évènement'];

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export function StatusBadge({ status }) {
  const s = NL_STATUS[status] || NL_STATUS.draft;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold" style={{ background: s.bg, color: s.text }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />{s.label}
    </span>
  );
}

export const cardCls = (light) => `rounded-xl border ${light ? 'bg-white border-gray-200 shadow-sm' : 'bg-[#1a0e2e] border-white/5'}`;
export const txtMain = (light) => (light ? 'text-gray-900' : 'text-white');
export const txtSub = (light) => (light ? 'text-gray-500' : 'text-white/50');
